const menu = [
  {
    title: 'Summary',
    list: [{ id: 'overview', text: 'Overview', href: '#overview' }],
  },
  {
    title: 'Terms and conditions',
    list: [
      { id: 'custom_terms', text: 'Definitions and Interpretation', href: '#customer-terms-of-service' },
      { id: 'user_terms', text: 'Use of Site', href: '#user-terms-of-service' },
      {
        id: 'customer_specific',
        text: 'Access',
        href: '#customer-specific-supplies',
      },
      { id: 'api_terms', text: 'Interfacing', href: '#api-terms-of-service' },
    ],
  },
  {
    title: 'Policies',
    list: [
      { id: 'privacy', text: 'Indemnity', href: '#privacy-shield-notice' },
      { id: 'acceptable_policy', text: 'No Warranties', href: '#acceptable-use-policy' },
      { id: 'finto_sub', text: 'Limitation of Liability', href: '#finto-sub-processors' },
    ],
  },
  {
    title: 'Confidentiality',
    list: [{ id: 'confidentiality', text: 'Confidentiality', href: '#confidentiality' }],
  },
  {
    title: 'Intellectual',
    list: [{ id: 'intellectual', text: 'Intellectual', href: '#intellectual' }],
  },
  {
    title: 'Security',
    list: [{ id: 'security', text: 'Security', href: '#security' }],
  },
  {
    title: 'Suspension & Termination',
    list: [{ id: 'suspension', text: 'Suspension & Termination', href: '#suspension' }],
  },
  {
    title: 'General',
    list: [{ id: 'general', text: 'General', href: '#general' }],
  },
  {
    title: 'Contact Details',
    list: [{ id: 'contact', text: 'Contact Details', href: '#contact' }],
  }
];

export default menu;
